// Mobile Menu Toggle
const menuBtn = document.getElementById('mobile-menu-button');
const menu = document.getElementById('main-nav');

if(menu && menuBtn){
    menuBtn.addEventListener('click', () => {
        menu.classList.toggle('open');
    });
}

// Glightbox
document.addEventListener('DOMContentLoaded', function () {
    GLightbox({
        selector: '.glightbox',
        touchNavigation: true,
        loop: true,
        zoomable: true,
        draggable: true,
        openEffect: 'zoom',
        closeEffect: 'fade'
    });
});

// Scroll Animation
const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('show');
            observer.unobserve(entry.target);
        }
    });
}, {
    threshold: 0.1
});

document.querySelectorAll('.reveal').forEach(el => {
    observer.observe(el);
});

// Loader
document.addEventListener('DOMContentLoaded', function () {

    const loader = document.getElementById('general-loader');

    // ================= SHOW / HIDE =================
    window.showLoader = function (show = true) {
        if (!loader) return;

        loader.classList.toggle('hidden', !show);
        loader.classList.toggle('flex', show);
    };

    // ================= LIVEWIRE =================
    document.addEventListener('livewire:init', () => {
        Livewire.hook('request', ({ respond, fail }) => {
            window.showLoader(true);

            respond(() => {
                window.showLoader(false);
            });

            fail(() => {
                window.showLoader(false);
            });
        });
    });

    // ================= PAGE NAVIGATION =================
    document.addEventListener('click', function (e) {
        const link = e.target.closest('a');

        if (!link) return;

        // Ignore modifier keys (Ctrl+Click, Cmd+Click, etc.)
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;

        // Ignore new tabs/windows
        if (link.target && link.target !== '_self') return;

        // Ignore downloads
        if (link.hasAttribute('download')) return;

        const href = link.getAttribute('href');

        // Ignore empty links
        if (!href || href === '') return;

        // Ignore javascript links
        if (href.startsWith('javascript:')) return;

        // Ignore same-page anchors (#section)
        if (href.startsWith('#')) return;

        const current = new URL(window.location.href);
        const target = new URL(link.href, window.location.origin);

        // Ignore links that only change the hash on the same page
        if (
            current.origin === target.origin &&
            current.pathname === target.pathname &&
            current.search === target.search &&
            current.hash !== target.hash
        ) {
            return;
        }

        // Ignore Livewire SPA navigation
        if (
            link.hasAttribute('wire:navigate') ||
            link.hasAttribute('wire:navigate.hover')
        ) {
            return;
        }

        window.showLoader(true);
    });

    // Hide loader when page finishes loading
    window.addEventListener('pageshow', () => {
        window.showLoader(false);
    });

});